import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { UiStorageService } from 'mbs-ui-shared@services/ui-storage.service';
import { catchError, of } from 'rxjs';

interface ApplicationState {
  footerExist: boolean;
  storage: Record<string, any>;
  storageLoaded: boolean;
  storageLoading: boolean;
}

const initialState: ApplicationState = {
  footerExist: false,
  storage: {},
  storageLoaded: false,
  storageLoading: false
};

export const ApplicationStore = signalStore(
  { providedIn: 'root' },
  withDevtools('ApplicationStore'),
  withState<ApplicationState>(initialState),
  withMethods((store, uiStorageService = inject(UiStorageService)) => ({
    loadStorage(force = false): void {
      if (!force && store.storageLoaded()) return;
      patchState(store, { storageLoading: true });
      uiStorageService
        .getSettings()
        .pipe(catchError(() => of({} as Record<string, any>)))
        .subscribe((payload) => {
          patchState(store, { storage: payload, storageLoaded: true, storageLoading: false });
        });
    },
    setFooterExist(footerExist: boolean): void {
      patchState(store, { footerExist });
    },
    setStorageSetting(key: string, value: any): void {
      patchState(store, { storage: { ...store.storage(), [key]: value } });
    },
    deleteStorageSetting(key: string): void {
      const { [key]: _, ...rest } = store.storage();
      patchState(store, { storage: rest });
    }
  }))
);

export type ApplicationStoreType = InstanceType<typeof ApplicationStore>;
